import { lang } from '@umu/ukit-lang';
import React from 'react';
import './upvote.scss';
import { components } from 'common';
const { Button } = components;
import { UpvoteType, LikeZeroShowType } from '@umu/umu-types';
import { classSet } from '@umu/umu-dom';

// // 当赞数为0时，文案展示类型，默认是TEXT_LIKE
// export enum LikeZeroShowType {
//     TEXT_LIKE, // ‘赞’
//     ZERO, // 展示的文案为0
// }

interface IProps {
    isUpvote: boolean; // 是否是点赞状态
    count: number; // 点赞数量
    clsName?: string;
    upvoteType?: UpvoteType; // 点赞图标类型
    likeZeroShowType?: LikeZeroShowType;
    clickCallback: (isUpvote: boolean) => void; // 点赞、点踩点击回调
    isDisable?: boolean;
}

export function Upvote(props: IProps) {
    const { clsName, isUpvote, count, clickCallback, likeZeroShowType = LikeZeroShowType.TEXT_LIKE } = props;
    let upvoteType = props.upvoteType;
    if (!upvoteType) {
        upvoteType = UpvoteType.NORMAL;
    }

    const onClick = () => {
        if (props.isDisable) {
            return;
        }
        clickCallback(!isUpvote);
    };

    function upvoteText() {
        if (likeZeroShowType === LikeZeroShowType.TEXT_LIKE && count === 0) {
            return <span className="count-tip">{lang('赞_Likes')}</span>;
        } else {
            return <span className="count">{count}</span>;
        }
    }

    const rootClassName = classSet(clsName || '', 'upvote', isUpvote ? 'active' : '');

    return (
        <div className={rootClassName}>
            <Button alias="text" onClick={onClick}>
                <i className={`icon upvote-icon ${upvoteType}`} />
                {upvoteText()}
            </Button>
        </div>
    );
}
